import * as types from './types';

export default {
  [types.SET_COMPANY](state, company) {
    state.company = company;
  },
  [types.CACHE_COMPANY](state, { key, company }) {
    state.cachedCompany[key] = company;
  },
  [types.SET_COMPANIES](state, companies) {
    state.companies = companies;
  },
  [types.CACHE_COMPANIES](state, { key, companies }) {
    state.companies[key] = companies;
  },
  [types.SET_COMPANY_BY_ID](state, company) {
    state.companyById = company;
  },
  [types.CACHE_COMPANY_BY_ID](state, { key, company }) {
    state.cachedCompanyById[key] = company;
  },
};
